import {
  HHFormControlLabel,
  HHRadio,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { Tooltip } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { ScopeableType } from '../../../types';
import {
  SCOPE_SELECTOR_RADIO_GROUP_TEST_ID,
  SCOPE_TYPE_LABELS,
  SCOPE_TYPE_RADIO_ORDER,
} from './scope-selector-constants';

export interface ScopeTypeRadioProps {
  disabled?: boolean;
  disabledTypes?: ScopeableType[];
  onTypeChange?: (next: ScopeableType) => void;
}

export const ScopeTypeRadio = ({
  disabled,
  disabledTypes = [],
  onTypeChange,
}: ScopeTypeRadioProps): JSX.Element => {
  const { control } = useFormContext();

  return (
    <HHStack direction="column" spacing={1}>
      <HHTypography hhVariant="caption" color="GrayText">
        Apply discount to
      </HHTypography>
      <Controller
        control={control}
        name="scopeableType"
        render={({ field: { onChange, value } }): JSX.Element => (
          <HHStack
            direction="row"
            flexWrap="wrap"
            sx={{ columnGap: 3, rowGap: 1 }}
            role="radiogroup"
            data-testid={SCOPE_SELECTOR_RADIO_GROUP_TEST_ID}
          >
            {SCOPE_TYPE_RADIO_ORDER.map(type => {
              const isOptionDisabled = disabled || disabledTypes.includes(type);
              const label = (
                <HHFormControlLabel
                  key={type}
                  label={SCOPE_TYPE_LABELS[type]}
                  control={
                    <HHRadio
                      hhVariant="primary"
                      value={type}
                      checked={value === type}
                      disabled={isOptionDisabled}
                      data-testid={`scope-type-radio-${type}`}
                      onChange={(e): void => {
                        const next = e.target.value as ScopeableType;
                        onChange(next);
                        onTypeChange?.(next);
                      }}
                    />
                  }
                />
              );
              return disabledTypes.includes(type) ? (
                <Tooltip key={type} title="Coming soon" placement="top">
                  <span>{label}</span>
                </Tooltip>
              ) : (
                label
              );
            })}
          </HHStack>
        )}
      />
    </HHStack>
  );
};
